import { ProjectAPI } from "@brg/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchTagPageProjectsCount = createAsyncThunk(
    'tagAdmin/fetchTagPageProjectsCount',
    async (args: any) => {
        const { filters } = args;

        const json = Promise.all(

            filters.map(async (filter: any) => {
                return ProjectAPI.GetList({ ...filter })
                .then((r) => r.json())
                .then(({ paging }) => {
                    return {
                        title: filter.requestTab,
                        count: paging?.count
                    }
                })
            })
            )

      return json;
    }
  );import { ProjectAPI } from "@brg/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchTagPageProjectsCount = createAsyncThunk(
    'tagAdmin/fetchTagPageProjectsCount',
    async (args: any) => {
        const { filters } = args;

        const json = Promise.all(

            filters.map(async (filter: any) => {
                return ProjectAPI.GetList({ ...filter })
                .then((r) => r.json())
                .then(({ paging }) => {
                    return {
                        title: filter.requestTab,
                        count: paging?.count
                    }
                })
            })
            )

      return json;
    }
  );